import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLanguage } from "./LanguageContext";
import { RevealWords, Reveal } from "./Reveal";
import { OrnamentDivider, CornerOrnament, IznikTexture } from "./Motifs";
import { IMAGES } from "./config";

export default function QuoteSection() {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const yImg = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="quote-section"
      className="relative bg-cream py-28 md:py-40 overflow-hidden"
    >
      {/* subtle iznik tile texture */}
      <IznikTexture size={340} />
      <div className="relative mx-auto max-w-6xl px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* clipped photo with parallax */}
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <div className="relative aspect-[3/4] overflow-hidden border border-gold/40">
              <CornerOrnament className="absolute left-2 top-2 z-10 w-11" />
              <CornerOrnament className="absolute right-2 top-2 z-10 w-11 rotate-90" />
              <CornerOrnament className="absolute bottom-2 right-2 z-10 w-11 rotate-180" />
              <CornerOrnament className="absolute bottom-2 left-2 z-10 w-11 -rotate-90" />
              <motion.img
                style={{ y: yImg }}
                src={IMAGES.couple}
                alt="Nurhan & Emre"
                className="absolute inset-0 h-[124%] w-full object-cover -top-[12%]"
                loading="lazy"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-cream/20" />
            </div>
          </Reveal>
        </div>

        {/* quote */}
        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <span className="font-sans text-xs uppercase tracking-[0.28em] text-pinky">
              02 — {t.quote.author}
            </span>
          </Reveal>
          <blockquote className="relative mt-6 font-display text-4xl md:text-6xl lg:text-7xl leading-[1.12] tracking-tight text-ink">
            <span
              aria-hidden="true"
              className="absolute -left-3 -top-10 md:-top-14 font-display italic text-7xl md:text-9xl text-gold/40 select-none"
            >
              “
            </span>
            <RevealWords text={t.quote.text} className="italic" />
            <span aria-hidden="true" className="font-display italic text-gold/70">
              ”
            </span>
          </blockquote>
          <div className="mt-10 flex items-center gap-4 max-w-sm">
            <OrnamentDivider className="w-full" />
          </div>
        </div>
      </div>
    </section>
  );
}
